export const aboutData = {
  title: "Building Trust, One Structure at a Time",
  story: "For over a decades, Aashi Constructions has been a trusted name in residential and commercial construction across Bangalore. Our commitment to quality materials, transparent practices, and timely delivery has made us the preferred choice for home buyers seeking reliable construction partners.",
  founderName: "Aashi Constructions",
  founderTitle: "Building Excellence Since 2015",
  storyImage: "https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg",
  noteImage: "https://res.cloudinary.com/dpt7mjxaj/image/upload/v1780567157/dongsh-xfucQ-oIbZY-unsplash_jckoqp.jpg",
  founderImage: "https://res.cloudinary.com/dpt7mjxaj/image/upload/v1780567157/poojan-thanekar--jk2BBoQxSk-unsplash_wj9yvc.jpg",
  founderNote: "With over a decade of hands-on experience in construction, Aashi Constructions was built on technical excellence and an unwavering commitment to quality.\n\nEvery project we undertake is approached with precision and care. We plan with intention, execute with discipline, and deliver with integrity—guided by deep respect for your investment, vision, and trust.\n\nOur strength lies in combining innovative construction techniques with modern technologies, ensuring every home is beautiful, functional, cost-effective, and built to last.\n\nThank you for considering Aashi Constructions. It would be our privilege to build your dream home.",
  values: [
    { title: "Quality", description: "Premium materials and superior craftsmanship in every project" },
    { title: "Transparency", description: "Clear communication and honest practices throughout construction" },
    { title: "Timeliness", description: "On-time delivery with strict adherence to project schedules" },
    { title: "Innovation", description: "Modern techniques and quality materials for lasting structures" }
  ]
};

export const aboutStats = [
  { label: "Homes Built", value: "25+" },
  { label: "Years of Experience", value: "10+" },
  { label: "Projects Delivered", value: "12+" },
  { label: "Client Satisfaction", value: "100%" }
];

export const aboutMission = "To provide quality construction services that exceed expectations, combining superior materials with expert craftsmanship. We are committed to transparent practices, timely delivery, and building lasting relationships with our clients. Every structure we build across Bangalore and beyond is a testament to our dedication to quality and our passion for creating spaces where families can thrive.";

export const contactInfo = {
  phones: ["+91 88848 19814", "+91 81500 36622"],
  emails: ["contact@aashigroups.in"],
  address: "RTO Office, 30/A, 15th Cross Rd, near Ullal, Jnananjyothinagar, Balaji Layout, Mallathahalli, Bengaluru, Karnataka 560056, India",
  hours: "Monday - Saturday: 9:00 AM - 5:30 PM IST"
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Projects", path: "/projects" },
  { name: "Packages", path: "/packages" },
  { name: "Services", path: "/services" },
  { name: "Contact", path: "/contact" }
];

export const quickLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Our Projects", path: "/projects" },
  { name: "Packages", path: "/packages" },
  { name: "Services", path: "/services" },
  { name: "Terms & Conditions", path: "/terms" }
];

export const footerServices = [
  "Architectural Design and Drawing",
  "Structural Design and Drawing",
  "Construction of Residential",
  "Interior Design and Drawing",
  "Renovation Works",
  "Vastu Plans",
  "Facility Management",
  "Project Management Consultant",
  "Quantity Survey",
  "Construction Planning",
  "Tender Services",
  "BBMP Building Licence"
];

export const budgetOptions = [
  { label: "Below 10 Lakhs", value: "Below 10 Lakhs" },
  { label: "10 - 25 Lakhs", value: "10 - 25 Lakhs" },
  { label: "25 - 50 Lakhs", value: "25 - 50 Lakhs" },
  { label: "50 Lakhs - 1 Crore", value: "50 Lakhs - 1 Crore" },
  { label: "1 - 2 Crore", value: "1 - 2 Crore" },
  { label: "2 - 5 Crore", value: "2 - 5 Crore" },
  { label: "Above 5 Crore", value: "Above 5 Crore" }
];
